<template>
  <div class="our-partners">

    <span class="title ff-myriad-pro fw-500">Our Partners</span>
    <div class="section-divider"></div>

    <div class="item-layout" :class="{'max-7': isMax7}">
      <div class="content" v-for="(item, index) in partners" :key="index">
        <div class="item">
          <img
            :width="item.image.width"
            :height="item.image.height"
            :src="'/th/plastics' + item.image.src"
            alt=""
          />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <p v-if="!isRemoveContactText" class="contact-text ff-myriad-pro">Contact us for technical data sheet and more details</p>

  </div>
</template>

<script setup>
const props = defineProps([
  'isMax7',
  'partners',
  'isRemoveContactText',
])
</script>

<style scoped>
.our-partners .title {
  font-size: calc(1.325rem + .9vw);
  line-height: 1.2;
  text-align: center;
  
  display: block;
  margin-bottom: 25px;
}

.our-partners .section-divider {
  width: 7%;
  margin: 45px auto 20px auto;
}

.our-partners .item-layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.our-partners .item-layout .content {
  width: 100%;
}

.our-partners .item-layout .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.our-partners .item-layout .item img {
  max-width: 100%;
  height: auto;
}

.our-partners .item-layout .item span {
  font-family: 'Open Sans';
  font-size: 18px;
  font-weight: 300;
  line-height: 1.2;
  color: #000000;
  padding-bottom: 25px;
  text-align: center;
}

.our-partners .contact-text {
  font-size: 17px;
  line-height: 30px;
  color: #5A5D67;
  text-align: center;
  letter-spacing: -0.2px;

  margin-bottom: 26px;
}

@media screen and (min-width: 768px) {
  .our-partners .item-layout {
    flex-direction: row;
  }

  .our-partners .item-layout .content {
    width: 20%;
  }

  .our-partners .item-layout.max-7 .content {
    width: calc(100% / 7);
  }
}

@media screen and (min-width: 1200px) {
  .our-partners .title {
    font-size: 2rem;
  }
}
</style>